import React from "react";
import "../home/home.css";

const HomeAbout = ({
  title,
  paragraphs,
  image,
  imageAlt = "About Image",
  reverse = false,
  items = [],
  note,
  background = "#ffffff",
  whatsappButton = false,
  actions = [],
  imageMaxHeight,
}) => {
  const contentAnimation = reverse ? "fade-left" : "fade-right";
  const imageAnimation = reverse ? "fade-right" : "fade-left";

  return (
    <section className="container-fluid py-5 overflow-hidden" style={{ background }}>
      <div className="container py-5">
        <div className={`row align-items-stretch ${reverse ? "flex-md-row-reverse" : ""}`}>

          <div
            className={image ? "col-md-6 d-flex flex-column justify-content-center" : "col-12 d-flex flex-column justify-content-center"}
            data-aos={contentAnimation}
            data-aos-duration="1400"
            data-aos-easing="ease-out-cubic"
            data-aos-once="true"
          >
            <h2 className="h2-title mb-4">{title}</h2>

            {paragraphs?.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {items.length > 0 && (
              <ul className="ps-3">
                {items.map((item, index) => (
                  <li key={index} className="mb-2 about-list-item">
                    <strong>{item.title}:</strong> {item.description}
                  </li>
                ))}
              </ul>
            )}

            {note && (
              <p><strong>Note:</strong> {note}</p>
            )}

            {whatsappButton && (
              <div
                className="mt-3"
                data-aos={contentAnimation}
                data-aos-delay="300"
                data-aos-duration="1400"
                data-aos-easing="ease-out-cubic"
              >
                <a
                  href="https://wa.me/971544792905"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mini-btn primary mt-4"
                >
                  Whatsapp Now
                </a>
              </div>
            )}

            {actions.length > 0 && (
              <div
                className="d-flex flex-wrap gap-3 mt-3"
                data-aos={contentAnimation}
                data-aos-delay="300"
                data-aos-duration="1400"
                data-aos-easing="ease-out-cubic"
              >
                {actions.map((btn, i) => (
                  <a
                    key={i}
                    href={btn.href}
                    target={btn.href.startsWith("http") ? "_blank" : undefined}
                    rel={btn.href.startsWith("http") ? "noopener noreferrer" : undefined}
                    className={btn.className}
                  >
                    {btn.label}
                  </a>
                ))}
              </div>
            )}
          </div>

          {image && (
            <div
              className="col-md-6 mt-4 mt-md-0"
              data-aos={imageAnimation}
              data-aos-duration="1400"
              data-aos-easing="ease-out-cubic"
              data-aos-once="true"
            >
              <div
                className="about-image-wrapper"
                style={imageMaxHeight ? { maxHeight: imageMaxHeight, overflow: "hidden" } : undefined}
              >
                <img src={image} alt={imageAlt} className="about-image" />
              </div>
            </div>
          )}

        </div>
      </div>
    </section>
  );
};

export default HomeAbout;
